import { captureException, captureMessage } from '@sentry/nextjs';
import { env } from 'lib/constants/env';

import { REVIEWS_BASE_URL } from './constants';

export interface JunipError {
  title: string;
  detail?: string;
}

export interface JunipErrors {
  errors: JunipError[];
}

export async function junip<T>(endpoint: string, method?: string): Promise<T> {
  const url = `${REVIEWS_BASE_URL}${endpoint}`;

  try {
    const response = await fetch(url, {
      method: method || 'GET',
      headers: {
        'Junip-Store-Key': env.NEXT_PUBLIC_JUNIP_STORE_KEY,
      },
    });

    if (!response.ok) {
      // Send Junip errors to Sentry
      const contentType = response.headers.get('Content-Type');
      if (contentType && contentType.includes('application/json')) {
        const { errors } = (await response.json()) as JunipErrors;
        errors.forEach((error) => {
          const message = `${error.title}${
            error.detail ? `: ${error.detail} ` : ''
          }`;
          captureMessage(message);
        });
      }
      throw new Error(
        `Failed to fetch data from ${url}: ${response.statusText}`,
      );
    }

    return (await response.json()) as T;
  } catch (error) {
    // Capture network-related errors and log them to Sentry
    captureException(error);
    throw error;
  }
}
